/**
 * Safely converts a value to a number or null.
 * As we have Decimals for prices this safely will convert those
 * Handles numbers, strings, and objects with a .toNumber() method (like Prisma Decimals).
 * Treats 0 as a valid number, and null/undefined/empty string as null.
 */
export const toNumberOrNull = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") return null;

  if (typeof value === "number") return value;

  if (
    typeof value === "object" &&
    value !== null &&
    "toNumber" in value &&
    typeof value.toNumber === "function"
  ) {
    return value.toNumber() as number;
  }

  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};
